export const initialState = {
    is_loading: false,
    total_holidays: 0,
    total_pages: 0,
    current_page: 1,
    holiday_list: [],
    search_value: "",
    sort_key: '',
    sort_direction: ''
}